import { ShootTypeSchema } from "@redotech/redo-model/inventory/image-generation";
import * as z from "zod/v4";

export const startImageOptimization = {
  name: "startImageOptimization" as const,
  input: z
    .object({
      productFamilyId: z.string().optional(),
      productId: z.string().optional(),
      sourceImageUrls: z.array(z.string()).min(1),
      shootType: ShootTypeSchema.optional(),
    })
    .refine((data) => data.productFamilyId || data.productId, {
      message: "Either productFamilyId or productId must be provided",
    }),
  output: z.object({
    workflowId: z.string(),
  }),
};
